import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import WoodenPallets from './pages/WoodenPallets';
import IndustrialPackaging from './pages/IndustrialPackaging';
import Quality from './pages/Quality';
import Industries from './pages/Industries';
import Contact from './pages/Contact';

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-sita-mani-global" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/wooden-pallets" element={<WoodenPallets />} />
            <Route path="/products/industrial-packaging" element={<IndustrialPackaging />} />
            <Route path="/quality-compliance" element={<Quality />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;